"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreLocaleReducer = exports.coreLocaleActions = exports.VALID_LANGUAGES = exports.TYPES_LOCALE = exports.DEFAULT_LANGUAGE = void 0;
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_LOCALE = 'coreLocale';
const TYPES_LOCALE = exports.TYPES_LOCALE = {
  SET_LANGUAGE: CORE_LOCALE + 'SetLanguage',
  SET_LABEL: CORE_LOCALE + 'SetLabel',
  SET_CODE: CORE_LOCALE + 'SetCode',
  SET_MSG: CORE_LOCALE + 'SetMsg',
  SET_CONTACT_US: CORE_LOCALE + 'SetContactUs',
  SET_PRIVACY_POLICY: CORE_LOCALE + 'SetPrivacyPolicy',
  SET_MENU_LABEL: CORE_LOCALE + 'SetMenuLabel',
  INIT: CORE_LOCALE + 'Init'
};
const VALID_LANGUAGES = exports.VALID_LANGUAGES = ['ja', 'en'];
const DEFAULT_LANGUAGE = exports.DEFAULT_LANGUAGE = VALID_LANGUAGES[0];
const INIT_STATE = {
  language: DEFAULT_LANGUAGE,
  label: {
    en: {},
    ja: {}
  },
  code: {},
  contactUs: {},
  privacyPolicy: {},
  menuLabel: {}
};
const coreLocaleActions = exports.coreLocaleActions = (0, _reduxActions.createActions)({
  [TYPES_LOCALE.SET_LANGUAGE]: function () {
    return {
      language: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOCALE.SET_LABEL]: function () {
    return {
      label: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOCALE.SET_CODE]: function () {
    return {
      code: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOCALE.SET_CONTACT_US]: function () {
    return {
      contactUs: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOCALE.SET_PRIVACY_POLICY]: function () {
    return {
      privacyPolicy: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES_LOCALE.SET_MENU_LABEL]: function () {
    return {
      menuLabel: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES_LOCALE.INIT);
const loadCode = codeJson => {
  const codeData = {};
  Object.keys(codeJson).forEach(codeType => {
    codeData[codeType] = codeJson[codeType].map(code => {
      return _objectSpread(_objectSpread({}, code), {}, {
        key: 'code.' + codeType + '.' + code.cd
      });
    });
  });
  return codeData;
};
const loadMenuLabel = menuLabel => {
  const menuLabelData = {};
  Object.keys(menuLabel).forEach(fid => {
    menuLabelData[fid] = menuLabel[fid];
  });
  return menuLabelData;
};
const coreLocaleReducer = exports.coreLocaleReducer = (0, _reduxActions.handleActions)({
  [TYPES_LOCALE.SET_LANGUAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      language: action.payload.language
    });
  },
  [TYPES_LOCALE.SET_LABEL]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      label: action.payload.label
    });
  },
  [TYPES_LOCALE.SET_CODE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      code: loadCode(action.payload.code)
    });
  },
  [TYPES_LOCALE.SET_CONTACT_US]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      contactUs: action.payload.contactUs
    });
  },
  [TYPES_LOCALE.SET_PRIVACY_POLICY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      privacyPolicy: action.payload.privacyPolicy
    });
  },
  [TYPES_LOCALE.SET_MENU_LABEL]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      menuLabel: loadMenuLabel(action.payload.menuLabel)
    });
  },
  [TYPES_LOCALE.INIT]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);